import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M200.3 248C212.7 229.3 215.4 210.7 216 192 215.5 173.3 212.7 154.7 200.3 136 192.3 124 175.2 124.6 167.6 136 155.2 154.7 152.5 173.3 151.9 192 152.4 210.7 155.2 229.3 167.6 248 175.7 260 192.8 259.4 200.3 248zM328.3 248C340.7 229.3 343.4 210.7 344 192 343.5 173.3 340.7 154.7 328.3 136 320.3 124 303.2 124.6 295.6 136 283.2 154.7 280.5 173.3 279.9 192 280.4 210.7 283.2 229.3 295.6 248 303.7 260 320.8 259.4 328.3 248zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.5 301.5 123 309.9 124.7 319.9 132.6 367.1 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-alt.js
// module id = e4oP
// module chunks = 144